import React from 'react';
import PropTypes from 'prop-types';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';
import LazyImage from '../../../HOC/lazyImage';
import { PhotoPlaceholder } from '../../../Placeholders/PhotoPlaceholder';
import { PhotoButton } from './PhotoButton';

const GalleryItem = ({
  id,
  url,
  isLoading = false,
  handleDelete,
  handleRotateRight,
  handleRotateLeft
}) => {
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id });

  const style = isDragging
    ? {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: 0.7,
        zIndex: 1
      }
    : {
        transform: CSS.Transform.toString(transform)
      };

  return isLoading ? (
    <PhotoPlaceholder handleDelete={handleDelete} />
  ) : (
    <div
      className="item-modal__photo-card"
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <PhotoButton action={handleDelete} additionalClass="delete" />
      <PhotoButton action={handleRotateRight} additionalClass="rotate-right" />
      <PhotoButton action={handleRotateLeft} additionalClass="rotate-left" />
      <LazyImage className="item-modal__photo" src={url} />
    </div>
  );
};

GalleryItem.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  isLoading: PropTypes.bool,
  handleDelete: PropTypes.func,
  handleRotateLeft: PropTypes.func,
  handleRotateRight: PropTypes.func
};

export default GalleryItem;
